import React, { useEffect, useRef } from 'react';
import PrivacyPolicy, { PrivacyPolicyText } from '../../../components/PrivacyPolicy';
import { isMobileOidc } from '../../../utilities/oidc/oidc';
import { useRegisterComponent } from '../../orchestrator';
import { pageId } from '../constants';
import { useSignupPageContext } from '../contexts/SignupPageContext';
import { useMicrobranding } from '../../../utilities/hooks/useMicrobranding';

export const SignupPrivacyPolicy = () => {
  useRegisterComponent(SignupPrivacyPolicy.name);

  const privacyPolicyMessageRef = useRef<HTMLParagraphElement>(null);

  const { isEmbedded, oidcContext } = useMicrobranding();

  const { setPrivacyPolicyText } = useSignupPageContext();

  useEffect(() => {
    const privacyPolicyText = privacyPolicyMessageRef.current?.innerHTML || '';

    if (privacyPolicyText) {
      setPrivacyPolicyText(privacyPolicyText);
    }
  }, [privacyPolicyMessageRef.current?.innerHTML, setPrivacyPolicyText]);

  return (
    <PrivacyPolicy
      isEmbedded={isEmbedded}
      isMobileOidc={isMobileOidc(oidcContext)}
      pageId={pageId}
      privacyPolicyText={PrivacyPolicyText.passwordSignup}
      ref={privacyPolicyMessageRef}
    />
  );
};
